export function base64UrlDecode(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
  return window.atob(padded);
}

export function parseJwt(token) {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const decoded = base64UrlDecode(parts[1]);
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}

export function getAnalyticsUserId() {
  if (typeof window === 'undefined') return null;
  // O JWT agora vive num cookie httpOnly (não legível por JS) — o userId
  // (não é segredo, só um identificador) é salvo à parte no login só pra
  // isso. Ver auth/Login.js.
  const userId = localStorage.getItem('userId');
  return userId ? Number(userId) : null;
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) {
    console.warn('Google Analytics não está disponível para rastrear o evento:', eventName);
    return;
  }

  console.log('Rastreando evento:', { eventName, ...params });
  window.gtag('event', eventName, {
    transport_type: 'beacon',
    ...params,
  });
}

export function trackButtonClick(eventName, extra = {}) {
  const userId = getAnalyticsUserId();
    trackEvent(eventName, {
    event_category: eventName,
    event_label: 'label'+eventName,
    ...(userId ? { user_id: userId } : {}),
    ...extra,
  });
}
